export const privacy = {
  title: '개인정보 처리방침',
  
  article1: {
    title: '제1조(수집하는 정보)',
    item1: '성명 또는 닉네임',
    item2: '이메일 주소',
    item3: '학습 언어, 언어 수준, 학습 목적',
    item4: '이용 이력, 참가 일시, 세션 관련 데이터(녹화·텍스트화 정보를 포함할 수 있습니다)',
    item5: '결제 관련 정보(신용카드 번호 등은 결제 대행 사업자가 관리하며, 운영은 보유하지 않습니다)'
  },
  
  article2: {
    title: '제2조(이용 목적)',
    item1: '본 서비스의 제공, 매칭, 운영 관리',
    item2: '이용자에게 연락, 통지, 지원 대응',
    item3: '서비스 품질 향상, 분석, 통계 처리',
    item4: '약관 위반, 부정 행위, 문제 대응',
    item5: '법령 또는 행정기관의 요청 대응'
  },
  
  article3: {
    title: '제3조(제3자 제공 및 위탁)',
    point1: '운영은 법령에 근거한 경우를 제외하고 본인의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.',
    point2: '다만, 결제, 시스템 운용, 통신 등을 외부 사업자에게 위탁할 수 있습니다.'
  },
  
  article4: {
    title: '제4조(국제적 데이터 이전)',
    point1: '본 서비스는 국제적으로 제공되므로 개인정보는 일본 및 해외(예: 캐나다)에서 저장·처리될 수 있습니다.',
    point2: '해당 데이터의 취급에 대해서는 일본법 및 본 방침에 따라 관리됩니다.'
  },
  
  article5: {
    title: '제5조(안전 관리 조치)',
    content: '운영은 개인정보의 유출, 멸실, 변조 등을 방지하기 위해 합리적인 기술적 및 조직적 안전 관리 조치를 강구합니다.'
  },
  
  article6: {
    title: '제6조(이용자의 권리)',
    content: '이용자는 자신의 개인정보에 대해 법령에 따라 열람, 정정, 삭제, 이용 정지 등을 요구할 수 있습니다. 다만, 운영의 정당한 업무 수행에 필요한 정보에 대해서는 요청에 응하지 못할 수 있습니다.'
  },
  
  article7: {
    title: '제7조(쿠키 등의 이용)',
    content: '운영은 편의성 향상 및 이용 상황 분석을 위해 쿠키 기타 유사 기술을 사용할 수 있습니다.'
  },
  
  article8: {
    title: '제8조(보존 기간)',
    content: '개인정보는 이용 목적에 필요한 기간 동안 보유하며, 그 후 적절한 방법으로 삭제하거나 익명화합니다.'
  },
  
  article9: {
    title: '제9조(방침의 변경)',
    content: '본 방침은 법령 또는 서비스 내용의 변경에 따라 사전 통지 없이 개정될 수 있습니다.'
  }
};
